import { defineMessages } from 'react-intl'

const ProgramContentPageMessages = {
  '*': defineMessages({}),
  ProgramContentBlock: defineMessages({
    theContentWillAt: {
      id: 'ProgramContentPageMessages.ProgramContentBlock.theContentWillAt',
      defaultMessage: 'The content will at',
    },
    backgroundMode: {
      id: 'ProgramContentPageMessages.ProgramContentBlock.backgroundMode',
      defaultMessage: 'Background mode',
    },
    currentlyInBackgroundMode: {
      id: 'ProgramContentPageMessages.ProgramContentBlock.currentlyInBackgroundMode',
      defaultMessage: 'Currently in Background mode.',
    },
    backgroundModeDescription: {
      id: 'ProgramContentPageMessages.ProgramContentBlock.backgroundModeDescription',
      defaultMessage: 'You can turn off the screen and continue listening to the content.',
    },
  }),
}
export default ProgramContentPageMessages
